import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
    searchEmployees,
    searchEmployeesFailure,
    searchEmployeesSuccess
} from 'src/app/root-store/ticket-store/actions/tickets.actions';
import { TicketService } from 'src/app/travelx/tickets/ticket.service';

@Injectable()
export class TicketEmployeeSearchEffects {
    constructor(private readonly _ticketService: TicketService, private readonly _actions$: Actions) {}

    searchEmployees$ = createEffect(() =>
        this._actions$.pipe(
            ofType(searchEmployees),
            switchMap((action) => {
                return this._ticketService.searchEmployees(action.query).pipe(
                    map((employees) => searchEmployeesSuccess({ employees })),
                    catchError((error) => of(searchEmployeesFailure({ error })))
                );
            })
        )
    );
}
